import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-validate-code',
  templateUrl: './validate-code.component.html',
  styleUrls: ['./validate-code.component.scss']
})
export class ValidateCodeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
